import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useGlobalState } from "@/context/GlobalStateContext";
import { scroller } from "react-scroll";
import Preloader from "@Common/Preloader/Preloader";
import Header from "@Common/Header/Header";
import PromoBlock from "@Common/PromoBlock/PromoBlock";
import Benefits from "@Common/Benefits/Benefits";
// import Partners from "@Common/Partners/Partners";
import Banner from "@Common/Banner/Banner";
import HowItWork from "@Common/HowItWork/HowItWork";
import FeedbackForm from "@Common/FeedbackForm/FeedbackForm";
import Footer from "@Common/Footer/Footer";
import PartnerDetails from "./components/Partners/PartnerDetails";
import Privacy from "./components/Privacy/Privacy";
import { trackEvent } from "@/utils/analytics";
import { useModalStore } from "@/store/useModalStore";
import MobileAppModal from "@/components/MobileAppModal/MobileAppModal";
import Paylater from "./components/Privacy/Paylater";
import Archive from "./components/Archive/Archive";
import Instructions from "./components/ Instructions/Instructions";
import CustomNotify from "./components/Notify/CustomNotify";
import PaylaterYandex from "./components/Privacy/PaylaterYandex";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

function HomePage() {
  const { siteVersion } = useGlobalState();
  const isClient = siteVersion === "client";

  return (
    <>
      <PromoBlock />
      <Benefits />
      {/* <Partners /> */}
      {!isClient && <FeedbackForm />}
      <Banner />
      <HowItWork />
      {isClient && <FeedbackForm />}
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { isOpen, type, closeModal } = useModalStore();

  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const id = location.hash.replace("#", "");
      let attempts = 0;
      const maxAttempts = 30;

      const tryScroll = () => {
        const el =
          document.querySelector(`[name="${id}"]`) ||
          document.getElementById(id);

        if (el) {
          scroller.scrollTo(id, {
            duration: 500,
            delay: 0,
            smooth: "easeInOutQuart",
            offset: -70,
          });
        } else if (attempts < maxAttempts) {
          attempts++;
          requestAnimationFrame(tryScroll);
        }
      };

      tryScroll();
    }
  }, [location]);
  useEffect(() => {
    const triggeredDepths = new Set();

    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const scrolledPercent = (scrollTop / docHeight) * 100;

      [25, 50, 75, 100].forEach((percent) => {
        if (scrolledPercent >= percent && !triggeredDepths.has(percent)) {
          triggeredDepths.add(percent);
          trackEvent("scroll_depth", { depth: `${percent}%` });
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkpoints = [30, 60, 120]; // секунды
    const timers = [];

    checkpoints.forEach((seconds) => {
      const timer = setTimeout(() => {
        trackEvent("time_on_page", { seconds });
      }, seconds * 1000);
      timers.push(timer);
    });

    return () => timers.forEach(clearTimeout);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className="width-limit">
        {loading ? <Preloader /> : null}
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/partner/:id" element={<PartnerDetails />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/paylater-oferta" element={<Paylater />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/instructions" element={<Instructions />} />
          <Route path="/paylater-yandex" element={<PaylaterYandex />} />
        </Routes>
      </div>
      <Footer />
      <ScrollToTop />
      <MobileAppModal
        isOpen={isOpen && type === "mobileApp"}
        onClose={closeModal}
      />
      <CustomNotify />
    </>
  );
}

export default App;
